import {
  getCarriers,
  getCarriersForSelect,
  createCarrier,
  getCarrierById,
  getCarriersGoHighWayDetails,
  editCarrier,
  addFactoring,
  carrierFuel,
  carrierPayment,
  assignCarrierAccess,
  getCarrierOfficeAccess,
  getCarrierAgentAccess,
  getCarrierBranchAccess,
  getCarrierPayments,
  getCarrierPaymentById,
  inactivateActivateCarrier,
  getPaymentsCarrierById,
  carrierPaymentTerm,
  addCarrierDocument,
  deleteCarrierDocument,
  addFuelCard,
  editFuelCard,
  deleteFuelCard,
  doNotLoad,
  carrierPaymentCarriers,
  payCarrierPaymentBatch,
  unPayCarrierPaymentBatch,
  searchCarriers,
  feeExempt,
  getAlerts,
  editAlert,
  deleteAlert,
  addAlert,
  getReviews,
  addReview,
  editReview,
  deleteReview,
  inviteCarrierApp,
  reInviteCarrierApp,
  editCarrierDocument,
  editW9,
  getReserve, changeReservePercent, getAllReserves, editCarrierSettings,
} from './carrier.action';

export { carrierReducer } from './carrier.reducer';
export { watchCarrier } from './carrier.saga';

export const carrierActions = {
  /** Create, Edit Carrier */
  createCarrier,
  inviteCarrierApp,
  reInviteCarrierApp,
  editCarrier,
  editCarrierSettings,
  editW9,
  /** End */

  /** Get Carriers */
  getCarriers,
  getCarriersForSelect,
  searchCarriers,
  getCarrierById,
  getCarriersGoHighWayDetails,
  /** End */

  /** Activate or Inactivate Carrier */
  inactivateActivateCarrier,
  /** End */

  /** Carrier Info */
  addFactoring,
  carrierFuel,
  carrierPayment,
  carrierPaymentTerm,
  /** End */

  /** Carrier Access */
  assignCarrierAccess,
  getCarrierOfficeAccess,
  getCarrierAgentAccess,
  getCarrierBranchAccess,
  /** End */

  /** Carrier Payment */
  getCarrierPayments,
  getCarrierPaymentById,
  getPaymentsCarrierById,
  carrierPaymentCarriers,
  payCarrierPaymentBatch,
  unPayCarrierPaymentBatch,
  /** End */

  /** Carrier Document */
  addCarrierDocument,
  deleteCarrierDocument,
  editCarrierDocument,
  /** End */

  /** Carrier Payment Fuel Card*/
  addFuelCard,
  editFuelCard,
  deleteFuelCard,
  /** End */

  /** Carrier Do not load */
  doNotLoad,
  /** End */

  /** Carrier Fee */
  feeExempt,
  /** End */

  /** Alert */
  getAlerts,
  addAlert,
  editAlert,
  deleteAlert,
  /** End */

  /** Review */
  getReviews,
  addReview,
  editReview,
  deleteReview,
  /** End */

  /** Reserve */
  getReserve,
  changeReservePercent,
  getAllReserves,
  /** End */
}

